import React from 'react';
import { Container, Paper, Typography, Box } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useTranslation, Trans } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';
import { isDemoEnv } from '../utils/environment';

const isDemo = isDemoEnv;

const APP_URL = isDemo ? 'https://demo.d2rh64qlfnffkx.amplifyapp.com/' : 'https://app.billivo.com/';

type LinkProps = {
  children?: React.ReactNode;
};

const AppLink: React.FC<LinkProps> = ({ children }) => (
  <a href={APP_URL} target="_blank" rel="noopener noreferrer">
    {children}
  </a>
);

const PaymentSuccess: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Container maxWidth="sm">
      <LanguageSwitcher />
      <Paper elevation={3} sx={{ p: 4, mt: 4, textAlign: 'center' }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            mb: 2,
          }}
        >
          <CheckCircleOutlineIcon sx={{ fontSize: 64, color: 'success.main', mb: 1 }} />
          <Typography variant="h4" gutterBottom>
            {t('paymentSuccess.title')}
          </Typography>
        </Box>

        <Typography variant="body1">
          {isDemo ? (
            <Trans
              i18nKey="paymentSuccess.descriptionDemo"
              components={{
                link: <AppLink />,
              }}
            />
          ) : (
            t('paymentSuccess.descriptionStandard')
          )}
        </Typography>
      </Paper>
    </Container>
  );
};

export default PaymentSuccess;
